import { render, staticRenderFns } from "./ManageAds.vue?vue&type=template&id=20d55525&scoped=true&"
import script from "./ManageAds.vue?vue&type=script&lang=js&"
export * from "./ManageAds.vue?vue&type=script&lang=js&"
import style0 from "./ManageAds.vue?vue&type=style&index=0&id=20d55525&lang=scss&scoped=true&"
import style1 from "./ManageAds.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ManageAds.vue?vue&type=style&index=2&id=20d55525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d55525",
  null
  
)

export default component.exports